import {Feather} from "@expo/vector-icons";
import {Platform} from "react-native";
import {Icon} from "native-base";
import * as React from "react";

export default function HeaderBackImage() {
  return <Icon as={Feather} name='chevron-left' marginLeft={2} marginTop={Platform.OS === 'ios' ? 0 : 1} />;
}
